import { MutationTree } from "vuex";
import { Casier } from "../../models/Casier";
import { Location } from "../../models/Location";
import { Niveau } from "../../models/Niveau";
import { Pavillon } from "../../models/Pavillon";
import { Periode } from "../../models/Periode";
import { TypeClientele } from "../../models/TypeClientele";
import { IUtilisateurState } from "../models";

export const stateDeBase = (): IUtilisateurState => {
  return {
    locations: [],
    nouvelleLocation: null,
    typeClientele: null,
    periode: null,
    niveau: null,
    pavillon: null,
    casier: null,
    montant: null,
    courriel: null,
    acceptationModalites: null,
    dateDebutCreationLocation: null,
    isDelaiLocationDepasse: null,
  };
};

export const state: IUtilisateurState = stateDeBase();

interface IMutations {
  initialiserDebutCreationLocation: (state: IUtilisateurState) => void;
  recupererLocationsUtilisateurSucces: (
    state: IUtilisateurState,
    payload: Location[]
  ) => void;
  recupererLocationsUtilisateurEchec: (state: IUtilisateurState) => void;
  creerNouvelleLocationSucces: (
    state: IUtilisateurState,
    payload: Location
  ) => void;
  sauvegarderTypeClientele: (
    state: IUtilisateurState,
    typeClientele: TypeClientele
  ) => void;
  sauvegarderPeriode: (state: IUtilisateurState, periode: Periode) => void;
  sauvegarderPavillon: (state: IUtilisateurState, pavillon: Pavillon) => void;
  sauvegarderNiveau: (state: IUtilisateurState, niveau: Niveau) => void;
  sauvegarderCasier: (state: IUtilisateurState, casier: Casier) => void;
  effacerStateUtilisateur: (state: IUtilisateurState) => void;
  sauvegarderMontant: (state: IUtilisateurState, montant: number) => void;
  sauvegarderCourriel: (state: IUtilisateurState, courriel: string) => void;
  sauvegarderAcceptationModalites: (
    state: IUtilisateurState,
    acceptation: boolean
  ) => void;
}

export const mutations: IMutations & MutationTree<IUtilisateurState> = {
  initialiserDebutCreationLocation: (state: IUtilisateurState) => {
    state.dateDebutCreationLocation = new Date();
  },
  recupererLocationsUtilisateurSucces: (
    state: IUtilisateurState,
    payload: Location[]
  ) => {
    state.locations = payload;
  },
  recupererLocationsUtilisateurEchec: (state: IUtilisateurState) => {
    state.locations = [];
  },
  creerNouvelleLocationSucces: (
    state: IUtilisateurState,
    payload: Location
  ) => {
    state.nouvelleLocation = payload;
  },
  sauvegarderTypeClientele: (
    state: IUtilisateurState,
    typeClientele: TypeClientele
  ) => {
    state.typeClientele = typeClientele;
    state.periode = null;
    state.pavillon = null;
    state.niveau = null;
    state.casier = null;
    state.acceptationModalites = null;
  },
  sauvegarderPeriode: (state: IUtilisateurState, periode: Periode) => {
    state.periode = periode;
    state.pavillon = null;
    state.niveau = null;
    state.casier = null;
    state.acceptationModalites = null;
  },
  sauvegarderPavillon: (state: IUtilisateurState, pavillon: Pavillon) => {
    state.pavillon = pavillon;
    state.niveau = null;
    state.casier = null;
    state.acceptationModalites = null;
  },
  sauvegarderNiveau: (state: IUtilisateurState, niveau: Niveau) => {
    state.niveau = niveau;
    state.casier = null;
    state.acceptationModalites = null;
  },
  sauvegarderCasier: (state: IUtilisateurState, casier: Casier) => {
    state.casier = casier;
    state.acceptationModalites = null;
  },
  effacerStateUtilisateur: (state: IUtilisateurState) => {
    Object.assign(state, stateDeBase());
  },
  sauvegarderMontant: (state: IUtilisateurState, montant: number) => {
    state.montant = montant;
  },
  sauvegarderCourriel: (state: IUtilisateurState, courriel: string) => {
    state.courriel = courriel;
  },
  sauvegarderAcceptationModalites: (
    state: IUtilisateurState,
    acceptation: boolean
  ) => {
    state.acceptationModalites = acceptation;
  },
};

export default {
  state,
  mutations,
};
